import request from '@/utils/zsm-requets';
import Qs from 'qs';
const order = '/zsm/api/order/' // 订单API
const afterSale = '/zsm/api/afterSale/' // 售后

/**
 * 售后详情内容
 * @param teacher_mobile 讲师账号
 * @param order_no 订单号
 * @param good_id 商品id
 * @param good_name 课程标题
 * @param buyer_name 买家姓名
 * @param buyer_mobile 买家手机号
 * @param applyBeginDate 申请开始售后时间
 * @param applyEndDate 申请售后结束时间
 * @param platformDict 平台类型
 * @param afterSaleProgress 售后状态
 * @param imminent 限时处理 24 or 48
 * @returns {*}
 */
export function afterSaleListData(info) {
  return request({
    url: afterSale + 'listData',
    method: 'post',
    params: info
  })
}
/**
 * 投诉近三十天数据
 * @param teacherMobile 讲师账号
 * @returns {*}
 */
export function queryOrderAfterSaleNum30(teacherMobile) {
  return request({
    url: afterSale + 'queryOrderAfterSaleNum30',
    method: 'post',
    params: { teacherMobile }
  })
}




/** 创建订单
 @param authorFee
 @param authorId
 @param authorMobile
 @param authorName
 @param avatar
 @param backDate
 @param backFee
 @param backFlag
 @param backOperator
 @param backReason
 @param buyerAvatar
 @param buyerMobile
 @param buyerName
 */
export function createOrder(info) {
  return request({
    url: order + 'create',
    method: 'post',
    params: info
  })
}

/** 删除订单
  @params id 订单id
 */
export function deleteOrder(id) {
  return request({
    url: order + 'create',
    method: 'post',
    params: { id }
  })
}

/** 
  * 获取订单列表
  *  @param id 订单id
  *  @param authorId 订单作者id
  * @param distId 分销者id
  *  @param shopId 门店id
  *  @param pageNo 当前页
  *  @param pageSize 每页条数
 */
export function listDataOrder(params) {
  return request({
    url: order + 'listData',
    method: 'post',
    params
  })
}
/** 
  * 订单导出
  *  @param id 订单id
  *  @param authorId 订单作者id
  * @param distId 分销者id
  *  @param shopId 门店id
  *  @param pageNo 当前页
  *  @param pageSize 每页条数
 */
export function excelListOrder(params) {
  return request({
    url: order + 'excelList',
    method: 'post',
    params
  })
}



/**
 * 根据订单号获取赠送订单列表
 *  @param id 赠送订单id
 *  @param orderId 父订单
 *  @param pageNo 当前页
 *  @param pageSize 每页条数
 */
export function orderGiveListData(info) {
  return request({
    url: order + 'orderGiveListData',
    method: 'post',
    params: info
  })
}

/**
 * 查看一个订单
 *  @param id 订单id
 */
export function getOrder(params) {
  return request({
    url: order + 'get',
    method: 'post',
    params
  })
}

/**
 * 查看一个订单
 *  @param orderNo 订单orderNo
 */
export function getByOrderNo(params) {
  return request({
    url: order + 'getByOrderNo',
    method: 'post',
    params
  })
}

/**
 * 修改私域订单备注
 * @param authorRemarks 备注
 * @param orderId 订单号
 * @returns {*}
 */
export function updateAuthorRemarks(orderId, authorRemarks) {
  return request({
    url: order + 'updateAuthorRemarks',
    method: 'post',
    params: { orderId, authorRemarks }
  })
}

/**
 * 讲师审核退款==>弃用
 * @param id 订单id
 * @param refundAuditProgress 修改的状态  同意则变为agree,拒绝显示reject
 * @param refundAuditReason 拒绝原因
 */

export function refundAuditOrder(params) {
  // return request({
  //   url: order + 'refundAudit',
  //   method: 'post',
  //   params
  // })
}
/**
 * 讲师审核退款
 * @param orderId 订单id
 * @param refnAuditProgress 修改的状态  同意则变为agree,拒绝显示reject
 * @param refondauditheson 审核原因
 * @param refundAuditReason 拒绝原因
 * @param refundAvditIagelne 凭证图
 */
export function refundTeacherAudit(params) {
  return request({
    url: order + 'refundTeacherAudit',
    method: 'post',
    params
  })
}

/**
 * 申诉列表
 * @param authorMObile 讲师账号
 */
export function appealList(params) {
  return request({
    url: order + 'appealList',
    method: 'post',
    params
  })
}


/**
 * 获取举证材料列表
 * @param orderId 订单编号
 */
export function queryAppealMaterial(params) {
  return request({
    url: order + 'queryAppealMaterial',
    method: 'post',
    params
  })
}


/**
 * 添加举证材料
 * @param appealId 申诉id
 * @param  appealType 1买家 2卖家 3平台
 * @param  appealReason 举证原因
 * @param  appealImages 举证图片
 * */
export function addAppealMaterial(params) {
  return request({
    url: order + 'addAppealMaterial',
    method: 'post',
    params
  })
}









/** 咨询类-更改订单状态
  @param consultCancelNote 取消原因
  @param consultProgress 修改的状态
  @param id 订单id
 */

export function consultProgress(params) {
  return request({
    url: order + 'consultProgress',
    method: 'post',
    params
  })
}
